// Google Maps link for a collection point.
// Prefers an explicit admin-pasted Maps URL (precise pin); otherwise
// auto-generates a Maps search link from the address text. No API key needed.
export const googleMapsLink = (address = '', mapsUrl = '') => {
  if (mapsUrl && mapsUrl.trim()) return mapsUrl.trim();
  if (address && address.trim()) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.trim())}`;
  }
  return '';
};
